import React, { ReactNode } from 'react'
import { DEFAULT_SETTINGS, Settings, SettingsContext } from './context'
import { useLocalStorage } from '../../hooks'

interface Props {
  children: ReactNode
}

export function SettingsProvider({ children }: Props) {
  const [savedSettings, setSettings] = useLocalStorage('settings_v20210410')

  const settings: Settings = {
    ...DEFAULT_SETTINGS,
    ...(savedSettings ?? {}),
  }

  const restoreDefaults = () => setSettings({})

  return <SettingsContext.Provider value={{ settings, setSettings, restoreDefaults }} children={children} />
}
